// src/locales/en/debitNote.js
export const debitNote = {
  // Page titles
  debitNotes: 'Debit Notes',
  allDebitNotes: 'All Debit Notes',
  createDebitNote: 'Issue Debit Note',
  debitNoteDetails: 'Debit Note Details',
  viewAndManageAllDebitNotes: 'View and manage all debit notes',
  createDebitNoteDescription: 'Manually issue a debit note against a supplier purchase order',

  // List columns
  debitNoteNumber: 'Debit Note #',
  supplier: 'Supplier',
  purchaseOrderNumber: 'Purchase Order',
  purchaseOrderBalance: 'PO Balance',
  sourceType: 'Source',
  amount: 'Amount',
  appliedAmount: 'Applied Amount',
  remainingAmount: 'Remaining Amount',
  status: 'Status',
  createdAt: 'Created At',
  actions: 'Actions',
  debitNoteDetailsTitle: 'Debit Note Details',
  offsetPayments: 'Offset Payments',
  sourceReturnToVendor: 'Source Return To Vendor',

  // Status labels — used via t(`debitNote.status_${debitNote.status}`)
  status_issued: 'Issued',
  status_applied: 'Applied',
  status_cancelled: 'Cancelled',

  // Source type labels — used via t(`debitNote.sourceType_${debitNote.sourceType}`)
  sourceType_return_to_vendor: 'Return To Vendor',
  sourceType_price_adjustment: 'Price Adjustment',
  sourceType_correction: 'Correction',

  // Form fields
  selectSupplier: 'Select Supplier',
  allSuppliers: 'All Suppliers',
  purchaseOrder: 'Purchase Order',
  selectPurchaseOrder: 'Select Purchase Order',
  purchaseOrderIdPlaceholder: 'Enter purchase order ID',
  amountPlaceholder: 'Enter amount',
  reason: 'Reason',
  reasonPlaceholder: 'Reason for issuing this debit note...',
  applyAmountLabel: 'Amount to Apply',

  // Actions
  create: 'Issue Debit Note',
  applyDebitNote: 'Apply Debit Note',
  cancelDebitNote: 'Cancel Debit Note',
  print: 'Print',
  printDebitNote: 'Print Debit Note',
  backToDebitNotes: 'Back to Debit Notes',

  // Confirmations
  confirmCancelDebitNote: 'Are you sure you want to cancel this debit note?',

  // Filters
  filterBySupplier: 'Filter by Supplier',
  filterByPurchaseOrder: 'Filter by Purchase Order',

  // Success / error messages
  debitNoteCreatedSuccessfully: 'Debit note {number} issued successfully',
  debitNoteAppliedSuccessfully: 'Debit note applied successfully',
  debitNoteCancelledSuccessfully: 'Debit note cancelled successfully',
  failedToCreateDebitNote: 'Failed to issue debit note',
  failedToLoadDebitNotes: 'Failed to load debit notes',
  failedToLoadDebitNote: 'Failed to load debit note',
  failedToApplyDebitNote: 'Failed to apply debit note',
  failedToCancelDebitNote: 'Failed to cancel debit note',
  someFieldsRequired: 'Please fix the highlighted fields before submitting',

  // Validation
  supplierRequired: 'Please select a supplier',
  purchaseOrderRequired: 'Please select a purchase order',
  amountMustBePositive: 'Amount must be greater than zero',
  applyAmountExceedsRemaining: 'Apply amount cannot exceed the remaining balance',
  reasonRequired: 'Please enter a reason',

  // Empty states
  noDebitNotesFound: 'No debit notes found',
  noDebitNotesYet: 'No debit notes yet.',
  noDebitNotesFoundDescription: 'No debit notes match your current filters',
  noDebitNotesYetDescription: 'Issue your first debit note to record a supplier credit against a purchase order.',
  issueFirstDebitNote: 'Issue First Debit Note',

  // Apply to a purchase order of the same supplier
  applyAmountExceedsPurchaseOrderBalance: 'Amount exceeds the outstanding balance of the selected purchase order',
};
